export default "__VITE_ASSET__uJxE02UI__"